export default __webpack_public_path__ + "static/media/19.08840de4.jpg";